import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
import { z } from "zod";
import { ensureElementVisible } from "@/lib/route-guards";

const SprzOpiekunPage = lazy(() => import("@/features/reports/sprz-opiekun-page"));

// `.catch(undefined)` na kazdym polu — zly param ze starego bookmarka ma zostac
// zignorowany, a nie wywalic trase ZodErrorem.
const searchSchema = z.object({
	listId: z.coerce.number().int().positive().optional().catch(undefined),
	mode: z.enum(["full", "toYesterday"]).optional().catch(undefined),
	apteka: z.enum(["z-internetowa"]).optional().catch(undefined),
});

export type SprzOpiekunSearch = z.infer<typeof searchSchema>;

export const Route = createFileRoute("/_auth/raporty/sprz-opiekun")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.raporty.sprz-opiekun",
			location.pathname,
		);
	},
	component: SprzOpiekunPage,
	validateSearch: (search: Record<string, unknown>): SprzOpiekunSearch =>
		searchSchema.parse(search),
});
